import React, { useCallback, useMemo } from 'react';
import css from './styles.module.scss';
import { Card, CardHeader, Grid, GridProps } from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';
import { DealContactsDealListItem } from '~/models/contacts.dto';
import { useRouteMatch } from 'react-router-dom';
import { useAppRoute } from '~/utils/hooks/useAppRoute';

type Props = GridProps & {
    deal: DealContactsDealListItem;
};

export const ContactDealCard: React.FC<Props> = ({ deal, ...props }) => {
    const match = useRouteMatch<{ creatorId: string }>();
    const route = useAppRoute();

    const dealDetailsRoute = useMemo(() => `/creators-list/${match.params.creatorId}/dashboard/deals/table/${deal.contractrefnum}/details`, [
        match,
        deal.contractrefnum,
    ]);
    const goToDealDetails = useCallback(() => route(dealDetailsRoute), [dealDetailsRoute, route]);

    return (
        <Grid item xs={12} {...props}>
            <Card elevation={0} className={css.contactCard} onClick={goToDealDetails}>
                <CardHeader
                    className={css.contactCardHeader}
                    avatar={
                        <AvatarGroup>
                            <Avatar
                                variant="square"
                                className={css.avatar}
                                alt={deal.contractTitle || ''}
                                src={deal.dealContactImage && `${process.env.REACT_APP_ASSET}${deal.dealContactImage}`}
                            />
                        </AvatarGroup>
                    }
                    title={deal.contractTitle}
                    subheader={deal.dealType}
                />
            </Card>
        </Grid>
    );
};
